"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdsAppNav = void 0;
var react_1 = __importDefault(require("react"));
var web_component_1 = require("./web-component");
var react_utils_1 = require("../utils/react-utils");
function PdsAppNav(props) {
    return (react_1.default.createElement(web_component_1.WebComponent, { tag: "pds-app-nav", attributes: {
            class: props.className,
            'data-allow-multiple-columns-in-secondary-menu': react_utils_1.toAttribute(props.dataAllowMultipleColumnsInSecondaryMenu)
        }, properties: {
            navigation: props.navigation,
            userNavigation: props.userNavigation,
            user: props.user
        }, listeners: {} }));
}
exports.PdsAppNav = PdsAppNav;

//# sourceMappingURL=pds-app-nav.js.map
